import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const StarIcon = observer('StarIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='starMask'
                width='12'
                height='12'
                x='2'
                y='2'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#1c1b1f'
                    d='m8 11.517-2.767 1.666a.6.6 0 0 1-.383.1.64.64 0 0 1-.35-.133.8.8 0 0 1-.233-.292.58.58 0 0 1-.034-.391l.734-3.15L2.517 7.2a.64.64 0 0 1-.184-.717.7.7 0 0 1 .2-.3.7.7 0 0 1 .367-.15l3.233-.283 1.25-2.967a.6.6 0 0 1 .259-.3.7.7 0 0 1 .358-.1q.184 0 .358.1a.6.6 0 0 1 .259.3l1.25 2.967 3.233.283a.7.7 0 0 1 .367.15.71.71 0 0 1 .225.675.64.64 0 0 1-.209.342l-2.45 2.117.734 3.15a.58.58 0 0 1-.034.391.8.8 0 0 1-.233.292.64.64 0 0 1-.35.133.6.6 0 0 1-.383-.1z'
                />
            </mask>
            <g mask='url(#starMask)'>
                <path
                    fill='#0b1627'
                    d='M-.022-.004h16v16h-16z'
                />
            </g>
        </SvgElement>
    );
});
